// 递归走 parent_id 拉文件夹祖先链(根→当前,含自身),供 folder-detail 面包屑完整路径。
// 零后端改动:复用 v_file_info_mine(owner 收口);每级一次 maybeSingle,React Query 整链缓存。
import { useQuery } from '@tanstack/react-query'
import { getSupabase } from '@dogdisk/shared'

export type AncestorNode = { id: string; name: string }

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

// 纯函数:逐级向上;链中断(null/error)即停,返回已拿到的部分(根→当前有序)。
export async function fetchAncestorChain(
  sb: ReturnType<typeof getSupabase>,
  folderId: string,
): Promise<AncestorNode[]> {
  const chain: AncestorNode[] = []
  let cur: string | null = folderId
  // 防环/防异常深度:文件树深度有限,设硬上限 64。
  for (let i = 0; cur && i < 64; i++) {
    // 显式标注结果类型:打破 cur ↔ data 的循环类型推断(TS7022)。
    const { data, error } = (await sb
      .from('v_file_info_mine')
      .select('id, name, parent_id, type')
      .eq('id', cur)
      .eq('type', 'folder')
      .maybeSingle()) as {
      data: { id: string; name: string; parent_id: string | null } | null
      error: unknown
    }
    if (error || !data) break
    chain.unshift({ id: data.id, name: data.name })
    cur = data.parent_id
  }
  return chain
}

export function useFolderAncestors(folderId: string) {
  return useQuery({
    queryKey: ['folder', 'ancestors', folderId] as const,
    enabled: UUID_RE.test(folderId),
    queryFn: () => fetchAncestorChain(getSupabase(), folderId),
  })
}
